import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'

interface PageUrlCellProps {
  page: string
}

export const PageUrlCell = ({ page }: PageUrlCellProps) => {
  return (
    <div>
      <BpAnchor className='flex-1 leading-5' href={page} target='_blank'>
        {page.split('?')[0]}
      </BpAnchor>
    </div>
  )
}
